import * as IconSelector from '../icons';

// Constantes exportadas
export const STATE_LIQUIDATION_NO_LIQUIDABLE = 'No Liquidable';
export const STATE_LIQUIDATION_POR_LIQUIDAR = 'Por Liquidar';
export const STATE_LIQUIDATION_LIQUIDADO = 'Liquidado';

// Definición del enum
export const statesLiquidation = [
    {
        value: STATE_LIQUIDATION_NO_LIQUIDABLE,
        label: 'No Liquidable',
        description: 'No se puede liquidar',
        icon: IconSelector.NotDefinedIcon,
        color: 'DarkOrange'
    },
    {
        value: STATE_LIQUIDATION_POR_LIQUIDAR,
        label: 'Por Liquidar',
        description: 'Pendiente de Liquidar',
        icon: IconSelector.PendingIcon,
        color: 'DarkRed'
    },
    {
        value: STATE_LIQUIDATION_LIQUIDADO,
        label: 'Liquidado',
        description: 'Se ha generado la liquidación',
        icon: IconSelector.LiquidacionesIcon,
        color: 'DarkGreen'
    }
];
